import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { Route, Switch } from 'react-router-dom';
import { ErrorPage } from 'src/components/error-page';
import { Loader } from './components/loader';
import { ROUTES } from './constants/routes';
import { useAuth } from './hooks';
import { CabinetPage, HomePage, LoginPage, NewsPage, NewsPostPage } from './pages';
import { InstructionPage } from './pages/instruction';
import { currentLocaleActions } from './slices/currentLocaleSlice';

const Routes = () => {
  const dispatch = useDispatch();
  const { i18n } = useTranslation();
  const { isRequired, handleRestoreAuth } = useAuth();
  const currentLocale = i18n.language;

  useEffect(() => {
    dispatch(currentLocaleActions.setCurrentLocale(currentLocale));
  }, [dispatch, currentLocale]);

  useEffect(() => {
    handleRestoreAuth();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (isRequired) {
    return <Loader minHeight="100vh" />;
  }

  return (
    <Switch>
      <Route path={ROUTES.HOME} component={HomePage} exact />
      <Route path={ROUTES.LOGIN} component={LoginPage} exact />
      <Route path={ROUTES.INSTRUCTION} component={InstructionPage} exact />
      <Route path={ROUTES.NEWS.ROOT} component={NewsPage} exact />
      <Route path={ROUTES.NEWS.POST} component={NewsPostPage} exact />
      <Route path={ROUTES.CABINET} component={CabinetPage} />
      <Route render={() => <ErrorPage errorCode={404} />} />
    </Switch>
  );
};

export const App = () => {
  const { i18n } = useTranslation();

  return (
    <Switch>
      <Route path={`/${i18n.language}`}>
        <Routes />
      </Route>
      <Route>
        <Routes />
      </Route>
    </Switch>
  );
};
